import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Grid from "@material-ui/core/Grid";
import Input from "Components/Input/Input";
import { read } from "Helpers/LocalStorage";
import { getStuffFitting } from "Stores/actions";
import { stuffList } from "Constants/TableColumns";
import { useTranslation } from 'react-i18next';
import RemoteTable from "Components/RemoteTable/RemoteTable";
import InnerCircularProgress from "Components/InnerCircularProgress/InnerCircularProgress";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";

function TblStuff({ selectedBrand }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [tblData, setTblData] = useState([]);
  const [tblPagination, setTblPagination] = useState({ Limit: 10, Page: 1, Total: 0 });
  const { refresh_stuff_list } = useSelector((state) => ({
    refresh_stuff_list: state.yaragh.refresh_stuff_list,
  }));

  useEffect(() => {
    if(selectedBrand) {
      getData();
    }
  },[selectedBrand]);

  useEffect(() => {
    if(refresh_stuff_list) {
      getData();
    }
  },[refresh_stuff_list]);

  const getData = async (page = 1, search = null) => {
    setLoading(true);
    setSearch("");
    const params = {
      KeyUser: read("userKey"),
      KeyGroup: read("groupKey"),
      Limit: tblPagination.Limit,
      Page: page,
      idBrandFitting: selectedBrand.Id,
      ...search
    };
    const result = await dispatch(getStuffFitting(params));
    if(result) {
      setTblData(result.list.map((item, index) => {
        return { num: (((result.pagination.Page - 1) * 5) + index + 1), idBrandFitting: selectedBrand.Id, ...item }
      }));
      setTblPagination(result.pagination);
    }
    setLoading(false);
  }

  const onTableChange = async (type, { page, sizePerPage }) => {
    setLoading(true);
    if (type === "pagination") {
      try {
        await getData(page);
        setTblPagination({
          ...tblPagination,
          Page: page
        })
      } catch (err) {
      console.error('[catch error]', err)
    }
    }
    setLoading(false);
  }

  const setValue = async (name, value) => {
    setSearch(value);
  }

  const onSearch = async (e) => {
    e.preventDefault();
    await getData(1, { name: search });
  }

  const onClearSearch = async (e) => {
    e.preventDefault();
    setSearch("");
    await getData(1);
  }

  return (
    <Grid container spacing={2}>
      <BackDropLoading loading={loading} />
      <Grid item xs={12} className="text-center py-2" style={{backgroundColor: '#E4E8E8'}}>
        <strong>{`${t('yaraghProductList')} ${selectedBrand.Name}`}</strong>
      </Grid>
      <Grid container>
        <Grid item lg={4} md={6} xs={12} className="my-2">
          <Input
            setValue={setValue.bind(this)}
            name="search"
            value={search}
            placeholder={t('nameSearch')}
            type="search"
            onSearch={onSearch}
            onClearSearch={onClearSearch}
          />
        </Grid>
        <RemoteTable
          data={tblData}
          keyField="num"
          columns={stuffList}
          loading={loading}
          page={tblPagination.Page}
          sizePerPage={tblPagination.Limit}
          sizePerPageList={[{ text: "10",value: 10 }]}
          totalSize={tblPagination.Total}
          onTableChange={onTableChange}
          noTitle
        />
      </Grid>
    </Grid>
  );
}

export default TblStuff;